import React from "react";
import { PAGES_PREFIX_PATH } from "constants/route.constant";
import { CLIENT, WELCOME, FREELANCER } from "constants/roles.constant";

const pagesRoute = [
  {
    key: "pages.accessDenied",
    path: `${PAGES_PREFIX_PATH}/access-denied`,
    component: React.lazy(() => import("views/pages/accessDenied")),
    authority: [CLIENT, WELCOME, FREELANCER],
  },
];

export default pagesRoute;
